import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { Toggle, StyledField } from 'libs/form';

export const LK = ({ lk_login }) => {
  const { t } = useTranslation();
  const useLogin = user.canUserLogin();
  if (!useLogin) {
    return null;
  }

  return (
    <>
      <StyledField type="text" label={t('form.Пароль ЛК')} name="lkpwd" noaf={true} withoutSpaces />
      {lk_login && <Toggle className="green-red force-gray" type="toggle" label={t('form.Безлимитный')} name="lk_unlimited" />}
    </>
  );
};
